(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('.footer-block__heading-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var block = this.closest('.footer-block--menu');
      var open = block.classList.toggle('is-open');
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // CRC: remove the Zip app's no-alt footer tile (narrow watcher on the payment list; self-disconnects).
  (function () {
    var list = document.querySelector('.footer__payment .list-payment');
    if (!list) { return; }
    function stripZipDuplicate() {
      list.querySelectorAll('img[src*="zipmoney"]').forEach(function (img) {
        var li = img.closest('.list-payment__item');
        if (li) { li.remove(); } else { img.remove(); }
      });
    }
    stripZipDuplicate();
    var obs = new MutationObserver(function () { stripZipDuplicate(); });
    obs.observe(list, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 30000);
  })();

  // CRC a11y: give untitled <iframe>s a descriptive title (clears Lighthouse iframe-title). Apps inject these late, so patch on load + timed passes.
  (function () {
    function titleFor(f) {
      var id = (f.id || '').toLowerCase(), src = (f.src || '').toLowerCase();
      if (/merchant/.test(id) || /google/.test(src)) return 'Customer reviews';
      if (/coax/.test(id) || /coax/.test(src)) return 'Live chat';
      if (/pixel/.test(id)) return 'Analytics';
      if (/pbar|predictive/.test(id)) return 'Store content';
      if (/automizely|aftership|popup|marketing/.test(id)) return 'Promotion';
      return 'Embedded content';
    }
    function patchFrames() {
      document.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach(function (f) {
        f.setAttribute('title', titleFor(f));
      });
    }
    patchFrames();
    window.addEventListener('load', patchFrames);
    [400, 1200, 2500, 5000, 9000].forEach(function (d) { setTimeout(patchFrames, d); });
  })();

  // CRC perf: shrink oversized Shopify-CDN lazy images that have no width param, before they load. Caps served width at displayed size x DPR; falls back to height-based estimate for logos sized by height + width:auto.
  (function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    function opt(img) {
      var src = img.getAttribute('src') || '';
      if (!/cdn\.shopify\.com/.test(src)) return;
      if (/[?&]width=/.test(src)) return;
      if (img.getAttribute('srcset')) return;
      var r = img.getBoundingClientRect();
      var w = Math.round(r.width);
      if (w < 8) { var h = Math.round(r.height); if (h > 4) { w = h * 4; } else { return; } }
      var target = Math.min(Math.ceil(w * dpr / 50) * 50, 1200);
      if (target < 60) target = 60;
      img.setAttribute('src', src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + target);
    }
    function run() { document.querySelectorAll('img[loading="lazy"]').forEach(opt); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    window.addEventListener('load', run);
    [300, 900, 1800].forEach(function (d) { setTimeout(run, d); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
